/**
 * Conteúdo ESTÁTICO da Capa (Home).
 *
 * A capa está sendo reconstruída por faixas; só o que a faixa atual usa vive
 * aqui. A lista de fallback das ações rápidas é fixa no código (decisão de
 * projeto); os destaques e o aviso do topo são dinâmicos.
 */

const ASSET = 'https://www.mpf.mp.br';

export interface AcaoRapidaLink {
  id: string;
  label: string;
  href: string;
  external?: boolean;
}

/**
 * Fallback do card "O que você deseja fazer hoje?" (bloco `mpfAcoesRapidas`).
 *
 * O mockup traz 8 linhas com rótulos genéricos ("Realizar ação principal do
 * usuário"); aqui elas são preenchidas com os serviços reais do MPF para o
 * fallback não exibir link morto enquanto a redação não edita o bloco.
 */
export const ACOES_RAPIDAS = {
  title: 'O que você deseja fazer hoje?',
  links: [
    {
      id: 'protocolo',
      label: 'Enviar documento pelo Protocolo',
      href: `${ASSET}/servicos/mpf-servicos-internas/protocolo`,
    },
    {
      id: 'denuncia',
      label: 'Registrar uma denúncia',
      href: `${ASSET}/servicos/mpf-servicos-internas/denuncias`,
    },
    {
      id: 'processos',
      label: 'Pesquisar processos e documentos',
      href: 'http://apps.mpf.mp.br/aptusmpf/portal',
      external: true,
    },
    {
      id: 'ouvidoria',
      label: 'Falar com a Ouvidoria',
      href: `${ASSET}/servicos/mpf-servicos-internas/ouvidoria`,
    },
    {
      id: 'certidao',
      label: 'Emitir certidão negativa',
      href: 'https://aplicativos.mpf.mp.br/ouvidoria/app/cidadao/certidao',
      external: true,
    },
    {
      id: 'concursos',
      label: 'Consultar concursos e estágios',
      href: `${ASSET}/o-mpf/concursos`,
    },
    {
      id: 'informacao',
      label: 'Solicitar acesso à informação',
      href: `${ASSET}/servicos/acesso-a-informacao`,
    },
    {
      id: 'carta',
      label: 'Ver a Carta de Serviços',
      href: `${ASSET}/servicos/carta-de-servicos-ao-cidadao`,
    },
  ] as AcaoRapidaLink[],
};
